export const VariantModelModule = angular
    .module('app.services.model.models.variantModel', [])
    .value('variantModel', {
        name: 'String',
        options: 'Array',
        priceDifferences: 'Array',
        tenant: 'String',
        revision: 'Number',
        imageLinkIds: 'Array'
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/model/models/variant.model.js